export default "__VITE_ASSET__ChoNOaOB__"